import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./AdLink.scss";
import { PageRoute, QueryParam } from "../../../models";
import config from "appConfig";
import { getAdUrl, getUrlParams } from "../../../services/utils";

const AdLink = ({ children, className = "", ad, onClick, target, listIndex = null, id = undefined }) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const searchType = urlParams.get("search_type");

  let to = getAdUrl(ad)

  if (searchType) {
    const searchQueryParsed = getUrlParams(location.search, QueryParam.searchQuery);
    const searchPage = (searchQueryParsed && searchQueryParsed.page) ? Number(searchQueryParsed.page) : 1;
    const sortOption = searchQueryParsed && searchQueryParsed.sortOption

    const params = new URLSearchParams();
    params.set("search_type", searchType);
    const searchQuery = urlParams.get("search_query");
    if (searchQuery) {
      params.set("search_query", searchQuery);
    }
    if (listIndex != null) {
      params.set("search_position", String((searchPage - 1) * config.maxAdPerPage + listIndex + 1));
    }
    params.set("search_page", String(searchPage));
    params.set("sortOption", String(sortOption))
    if (ad.isPromoted) {
      params.set("is_promoted", "1");
    }
    to = `${to}?${params.toString()}`;
  }

  return (
    <Link
      id={id}
      className={className ? `${styles.link} ${className}` : styles.link}
      title={ad.title}
      to={to}
      onClick={onClick}
      target={target}
    >
      {children}
    </Link>
  );
};

export default AdLink;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdLink/AdLink.tsx